
import React from 'react';
import { Controller, Control } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface RHFDateTimePickerProps {
  name: string;
  label?: string;
  control: Control<any>;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  placeholder?: string;  
  fullWidth?: boolean,
  className?: string,
  style?:any
}

const RHFDateTimePicker: React.FC<RHFDateTimePickerProps> = ({
  control,
  name,
  label,
  error = false,
  helperText,
  required = false,
  placeholder,
  fullWidth = false,
  className,
  style
}) => (
  <div className={`form-group ${className ? className :"form-fullwidth"}`}
  style={style ? style : {}}>
    {label && <label htmlFor={name}>
      {label} {required && <span style={{ color: 'red' }}>*</span>}
    </label>}

    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          {...field}
          id={name}
          selected={field.value}
          onChange={(date) => field.onChange(date)}
          showTimeSelect
          dateFormat="Pp"
          className={`date-picker-input ${error ? 'error' : ''}`}

          
        />
      )}
    />

    {helperText && error && (
      <small className="error-text" style={{ color: 'red' }}>
        {helperText}
      </small>
    )}
  </div>
);

export default RHFDateTimePicker;
